module.exports = __webpack_public_path__ + "static/media/vaccine-program-mobile.8e9a86b9.png";